<div class="colored-bg-wrapper bg" [ngClass]="{'jump-splash-page': isJumpRoute}" [style.background-image]="'url(' + logoutBgImage + ')'">
  <div class="colored-bg-container vertical-align">
    <form class="colored-bg-content full-width" novalidate>
      <div class="header-block">
        <h2 class="formTitle">{{ isJumpRoute ? 'Jumphire' : 'yeehro' }}</h2>
      </div>

      @if (errorMessage) {
        <div>
          <p style="color: red;">{{ errorMessage }}</p>
        </div>
      }

      <div class="main">
        <p>You have been logged out.</p>
      </div>

      @if (loginAvailable) {
        <form novalidate (ngSubmit)="login()">
          <div class="submit-wrapper">
            <button type="submit" class="btn btn-primary btn-lg btn-block signin-btn">Login</button>
            <!-- <button type="submit" mat-flat-button color="primary">Login</button> -->
          </div>
        </form>
      }
    </form>
  </div>


  <div class="floating-logo">
    <!-- <img src="/uploads/system_images/yeeHRologo.png" width="200"> -->
    @if (!isJumpRoute) {
      <img src="/uploads/system_images/yeeHRologo.png" width="200" alt="YeeHRo Logo" />
    }
    @if (isJumpRoute) {
      <img src="/uploads/system_images/jumpHirelogo.png" width="200" alt="JumpHire Logo" />
    }
  </div>
</div>
